import { createEntityAdapter } from '@reduxjs/toolkit';

import { State } from 'Libs/redux/reducer';

import { DrawerContent } from './content-drawer.types';

export const drawerContentAdapter = createEntityAdapter<DrawerContent>({
  selectId: (item) => item.uiId,
});

export const {
  selectAll,
  selectById: selectByIdFromAdapter,
  selectEntities,
  selectIds,
  selectTotal,
} = drawerContentAdapter.getSelectors();

export const selectAllDrawerContents = (state: State) => selectAll(state.entities.drawerContent);

export const selectDrawerContentsMetadata = (state: State) => state.entities.drawerContent.metadata;
